import { postFor } from '../../../../../ReactComponents/API';
import { CheckoutApiRoutes } from '../../../CheckoutApiRoutes.csharp';
import { VippsInitiatePaymentType } from '../../PaymentMethods/Vipps/VippsInitiatePaymentType.csharp';

export interface IVippsPaymentApi {
    redirectToVipps: (phoneNumber: string, paymentType: VippsInitiatePaymentType) => Promise<void>;
}

export class VippsPaymentApi implements IVippsPaymentApi {
    private routes: CheckoutApiRoutes;

    constructor(routes: CheckoutApiRoutes) {
        this.routes = routes;
    }

    public redirectToVipps = async (phoneNumber: string, paymentType: VippsInitiatePaymentType): Promise<void> => {
        return postFor<string>(this.routes.vippsUrl, { phoneNumber, paymentType })
            .then((url) => {
                window.location.href = url;
            })
            .catch((e) => {
                console.log(e);
                window.location.href =
                    paymentType === VippsInitiatePaymentType.Standard
                        ? this.routes.paymentValidationErrorRedirectUrl
                        : this.routes.vippsExpressErrorRedirectUrl;
            });
    };
}
